import PropTypes from 'prop-types';
import React from 'react';
import { Image } from 'Components';
import loaderSVG from 'assets/loader.svg';
import loaderGIF from 'assets/loader.gif';
import isEdgeIE from 'helpers/detectEdgeIE';
import './Loader.css';

const Loader = ({
  fadeOut,
  isSolidWhite,
  isSmall,
  style,
}) => (
  <div style={{ height: '100%', overflow: 'hidden', ...style }}>
    <div className={`loader ${fadeOut ? 'loader--fade' : ''} ${isSolidWhite ? 'loader--solid-white' : ''}`}>
      <div className={`loader__wrapper${!isSmall ? '' : '--small'}`}>
        <Image src={isEdgeIE() ? loaderGIF : loaderSVG} />
      </div>
    </div>
  </div>
);
Loader.propTypes = {
  fadeOut: PropTypes.bool,
  isSolidWhite: PropTypes.bool,
  isSmall: PropTypes.bool,
  style: PropTypes.shape({}),
};

Loader.defaultProps = {
  style: {},
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.jsx